// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as PlUtils from "../player/PlUtils.bs.js";
import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as TraitName0 from "common/src/tft-static/TraitName0.bs.js";
import * as ApertureCtx from "../ctx/ApertureCtx.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as StatsTable2 from "../components/StatsTable2.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as LpChartUtils from "common/src/LpChartUtils.bs.js";
import * as TraitTooltip from "common/src/tft-static/TraitTooltip.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import Switch from "@mui/material/Switch";
import * as Belt_MutableMapString from "rescript/lib/es6/belt_MutableMapString.js";
import FormControlLabel from "@mui/material/FormControlLabel";

function getCols(showLp) {
  return Belt_Array.concat([
              StatsTable2.col(false, undefined, (function (param, param$1) {
                      return param$1.t("Trait");
                    }), undefined, (function (param, param$1, param$2) {
                      var match = param[0];
                      var rank = match[1];
                      var traitId = match[0];
                      var set = TftSet.use(undefined);
                      var c = Sd.traitRankUnitCount(traitId, rank, set);
                      if (rank === 0) {
                        return React.createElement(TraitTooltip.make, {
                                    trait: traitId,
                                    children: React.createElement("div", {
                                          className: "flex items-center"
                                        }, React.createElement(TraitImage.PlainIcon.make, {
                                              traitId: traitId,
                                              size: 28
                                            }), React.createElement("div", {
                                              className: "pl-2 font-roboto font-normal truncate"
                                            }, React.createElement(TraitName0.make, {
                                                  trait: traitId
                                                })))
                                  });
                      } else {
                        return React.createElement(TraitTooltip.make, {
                                    trait: traitId,
                                    rank: rank,
                                    children: React.createElement("div", {
                                          className: "flex items-center"
                                        }, React.createElement(TraitImage.PlainIcon.make, {
                                              traitId: traitId,
                                              rank: rank,
                                              size: 28
                                            }), React.createElement("div", {
                                              className: "pl-2 font-roboto font-normal truncate"
                                            }, String(c) + " ", React.createElement(TraitName0.make, {
                                                  trait: traitId
                                                })))
                                  });
                      }
                    }), undefined, undefined, undefined, (function (param, param$1, param$2) {
                      var match = param[0];
                      return param$2.traitsT(match[0]) + String(match[1]);
                    }), undefined, 160, undefined, undefined),
              StatsTable2.col(undefined, true, (function (param, param$1) {
                      return param$1.t("Games");
                    }), undefined, (function (param, param$1, param$2) {
                      return String(param[1].count);
                    }), undefined, undefined, undefined, (function (param, param$1, param$2) {
                      return param[1].count;
                    }), undefined, 80, undefined, undefined),
              StatsTable2.col(false, true, (function (param, param$1) {
                      return param$1.t("Place");
                    }), undefined, (function (param, param$1, param$2) {
                      return param[1].place.toFixed(2);
                    }), undefined, undefined, undefined, (function (param, param$1, param$2) {
                      return param[1].place;
                    }), undefined, 75, undefined, undefined),
              StatsTable2.col(undefined, true, (function (param, param$1) {
                      return param$1.t("Top 4");
                    }), undefined, (function (param, param$1, param$2) {
                      var v = param[1];
                      return Global.formatPct(undefined, Global.f(v.top4) / Global.f(v.count)) + "%";
                    }), undefined, undefined, undefined, (function (param, param$1, param$2) {
                      var v = param[1];
                      return Global.f(v.top4) / Global.f(v.count);
                    }), undefined, 75, undefined, undefined),
              StatsTable2.col(undefined, true, (function (param, param$1) {
                      return param$1.t("Win");
                    }), undefined, (function (param, param$1, param$2) {
                      var v = param[1];
                      return Global.formatPct(undefined, Global.f(v.top1) / Global.f(v.count)) + "%";
                    }), undefined, undefined, undefined, (function (param, param$1, param$2) {
                      var v = param[1];
                      return Global.f(v.top1) / Global.f(v.count);
                    }), undefined, 75, undefined, undefined)
            ], showLp ? [StatsTable2.col(undefined, true, (function (param, param$1) {
                        return param$1.t("LP");
                      }), undefined, (function (param, param$1, param$2) {
                        var v = param[1];
                        return (
                                v.lp > 0 ? "+" : ""
                              ) + String(v.lp);
                      }), undefined, undefined, undefined, (function (param, param$1, param$2) {
                        return param[1].lp;
                      }), undefined, 70, undefined, undefined)] : []);
}

function PlTraitsSummary(Props) {
  var showLp = Props.showLp;
  var games = Props.games;
  var top = Props.top;
  var isDuo = Props.isDuo;
  var scrollRef = Props.scrollRef;
  var t = Translation.useT(/* Common */0);
  var match = React.useState(function () {
        return true;
      });
  var setSplit = match[1];
  var split = match[0];
  var screenSize = ScreenAtom.use(undefined);
  ScreenAtom.isMobile(screenSize);
  ApertureCtx.useValue(undefined);
  var set = TftSet.use(undefined);
  var data = React.useMemo((function () {
          var traitGroups = Belt_MutableMapString.make(undefined);
          Belt_Array.forEach(games, (function (hero) {
                  var traits = Belt_Array.keepMap(hero.info.traits, (function (t) {
                          if (t.currentTier > 0) {
                            return [
                                    t.name,
                                    split ? t.currentTier : 0
                                  ];
                          }
                          
                        }));
                  return Belt_Array.forEach(traits, (function (param) {
                                var traitId = param[0] + "-" + String(param[1]);
                                var group = Belt_MutableMapString.getWithDefault(traitGroups, traitId, []);
                                var match = hero.rankBefore;
                                var match$1 = hero.rankAfter;
                                var rankChange;
                                var exit = 0;
                                if (match !== undefined && match$1 !== undefined) {
                                  var before = LpChartUtils.divisionToBase(match[0], set) + match[1] | 0;
                                  var after = LpChartUtils.divisionToBase(match$1[0], set) + match$1[1] | 0;
                                  rankChange = after - before | 0;
                                } else {
                                  exit = 1;
                                }
                                if (exit === 1) {
                                  rankChange = hero.queueId === 1100 ? PlUtils.getEstimatedLp(hero.info.placement) : 0;
                                }
                                group.push([
                                      hero.info.placement,
                                      rankChange
                                    ]);
                                return Belt_MutableMapString.set(traitGroups, traitId, group);
                              }));
                }));
          var traitGroups$1 = Belt_SortArray.stableSortBy(Belt_Array.keep(Belt_MutableMapString.toArray(traitGroups), (function (param) {
                      var k = param[0];
                      if (!k.includes("Tormented") && !k.includes("Boss")) {
                        return !k.includes("Emperor");
                      } else {
                        return false;
                      }
                    })), (function (param, param$1) {
                  return -Caml.caml_int_compare(param[1].length, param$1[1].length) | 0;
                }));
          var traitGroups$2 = Belt_SortArray.stableSortBy(traitGroups$1, (function (tg1, tg2) {
                  return -Caml.caml_int_compare(tg1[1].length, tg2[1].length) | 0;
                }));
          var minCount = Caml.caml_int_min(5, Belt_Option.mapWithDefault(Belt_Array.get(traitGroups$2, 24), 0, (function (param) {
                      return param[1].length;
                    })));
          var len = traitGroups$2.findIndex(function (param) {
                return param[1].length < minCount;
              });
          var traitGroups$3 = len === -1 ? traitGroups$2 : Belt_Array.slice(traitGroups$2, 0, len);
          return Belt_Array.map(traitGroups$3, (function (param) {
                        var places = param[1];
                        var s = param[0].split("-");
                        var traitId = Belt_Array.getExn(s, 0);
                        var rank = Belt_Option.getExn(Belt_Int.fromString(Belt_Array.getExn(s, 1)));
                        var c = places.length;
                        var avg = Global.f(Belt_Array.reduce(places, 0, (function (acc, param) {
                                    var p = param[0];
                                    return acc + (
                                            isDuo ? T.duoPlace(p) : p
                                          ) | 0;
                                  }))) / Global.f(places.length);
                        var top4 = Belt_Array.keep(places, (function (param) {
                                var p = param[0];
                                if (p <= 4) {
                                  return p >= 1;
                                } else {
                                  return false;
                                }
                              })).length;
                        var win = Belt_Array.keep(places, (function (param) {
                                var p = param[0];
                                if (isDuo) {
                                  return p <= 2;
                                } else {
                                  return p === 1;
                                }
                              })).length;
                        var lp = Belt_Array.reduce(places, 0, (function (acc, param) {
                                return acc + param[1] | 0;
                              }));
                        return [
                                [
                                  traitId,
                                  rank
                                ],
                                {
                                  count: c,
                                  place: avg,
                                  top4: top4,
                                  top1: win,
                                  lp: lp
                                }
                              ];
                      }));
        }), [
        games,
        split
      ]);
  var keyFn = React.useCallback((function (v) {
          return v[0][0] + String(v[0][1]);
        }), []);
  var cols = React.useMemo((function () {
          return getCols(showLp);
        }), [showLp]);
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "pt-1 pl-6"
                }, React.createElement(FormControlLabel, {
                      control: React.createElement(Switch, {
                            checked: split,
                            onChange: (function (e) {
                                return Curry._1(setSplit, e.target.checked);
                              }),
                            size: "small"
                          }),
                      label: t("Split by trait tier")
                    })), React.createElement(StatsTable2.make, {
                  cols: cols,
                  data: data,
                  context: undefined,
                  keyFn: keyFn,
                  stickyColCount: 1,
                  top: top,
                  defaultSortIdx: 1,
                  scrollEl: [
                    scrollRef,
                    0
                  ]
                }));
}

var make = React.memo(PlTraitsSummary);

export {
  getCols ,
  make ,
  
}
/* make Not a pure module */
